import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ArticlePlaceholder({
  onClick
}) {
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "100%",
    cursor: "pointer",
    onClick: onClick,
    children: /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.edit.fields.articleBody.placeholder"
      })
    })
  });
}